import React from "react"
import { MyUIHelpers } from "@macashipo/mlib"

const MWContent = React.lazy(() => import("./Types/WContent"))
const MUnsupportedMedia = React.lazy(() => import("./Types/UnsupportedMedia"))
/** Quote */
const MQuoteMasterInfo = React.lazy(
  () => import("./Types/Quote/QuoteMasterInfo")
)
const MQuoteDetail = React.lazy(() => import("./Types/Quote/QuoteDetail"))
const MQuoteTemplates = React.lazy(() => import("./Types/Quote/QuoteTemplates"))
const MQuoteCustomer = React.lazy(() => import("./Types/Quote/QuoteCustomer"))
const MQuoteProgress = React.lazy(
  () => import("./Types/Quote/QuoteDetailProgress")
)
const MQuoteDetailList = React.lazy(
  () => import("./Types/Quote/QuoteDetailList")
)
const MQuoteTemplateAddition = React.lazy(
  () => import("./Types/Quote/QuoteTemplateAddition")
)
const MQuoteDetailAddition = React.lazy(
  () => import("./Types/Quote/QuoteDetailAddition")
)
const MQuotePartDelete = React.lazy(
  () => import("./Types/Quote/QuotePartDelete")
)
const MQuoteDetailFormAddition = React.lazy(
  () => import("./Types/Quote/QuoteDetailFormAddition")
)
const MQuoteTemplateAdditionNew = React.lazy(
  () => import("./Types/Quote/QuoteTemplateAdditionNew")
)
const MPartReceivedDetailReport = React.lazy(
  () => import("./Types/PartReceivedDetailReport")
)
/** Job Order */
const MJOMasterInfo = React.lazy(() => import("./Types/JobOrder/JOMasterInfo"))
const MJOIssueParts = React.lazy(() => import("./Types/JobOrder/JOIssueParts"))
const MJODetail = React.lazy(() => import("./Types/JobOrder/JODetail"))
const MJODetailList = React.lazy(() => import("./Types/JobOrder/JODetailList"))
const MClientMainConcern = React.lazy(
  () => import("./Types/JobOrder/ClientMainConcern")
)
const MQuoteClientMainConcern = React.lazy(
  () => import("./Types/Quote/ClientMainConcern")
)
/** Output Stock */
const MOSMasterInfo = React.lazy(
  () => import("./Types/OutputStock/OSMasterInfo")
)
const MOSJobDetail = React.lazy(() => import("./Types/OutputStock/OSJobDetail"))
const MOSIssueParts = React.lazy(
  () => import("./Types/OutputStock/OSIssueParts")
)
const MOSIssuePartsAddition = React.lazy(
  () => import("./Types/OutputStock/OSIssuePartsAddition")
)
const MOSPartIssuedDetail = React.lazy(
  () => import("./Types/OutputStock/OSPartIssuedDetail")
)
const MOSPartIssuedDelete = React.lazy(
  () => import("./Types/OutputStock/OSPartIssuedDelete")
)
/** Order Stock */
const MCreateOrderStockMasterInfo = React.lazy(
  () => import("./Types/CreateOrderStock/OrderStockMasterInfo")
)
const MCreateOrderStockDetail = React.lazy(
  () => import("./Types/CreateOrderStock/OrderStockDetail")
)
const MCreateOrderStockDetailList = React.lazy(
  () => import("./Types/CreateOrderStock/OrderStockDetailList")
)
const MCreateOrderStockList = React.lazy(
  () => import("./Types/CreateOrderStock/OrderStockList")
)
const MOrderStockMasterInfo = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockMasterInfo")
)
const MOrderStockSupplier = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockSupplier")
)
const MOrderStockDetail = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockDetail")
)
const MOrderStockDetailList = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockDetailList")
)
const MOrderStockDetailTimeline = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockDetailTimeline")
)
const MUIOrderStockAddNewPart = React.lazy(
  () => import("./Types/OrderStockDetail/OrderStockAddNewPart")
)
/** Sale Order */
const MSOMasterInfo = React.lazy(() => import("./Types/SaleOrder/SOMasterInfo"))
const MSOIssueParts = React.lazy(() => import("./Types/SaleOrder/SOIssueParts"))
const MSODetail = React.lazy(() => import("./Types/SaleOrder/SODetail"))
const MSODetailList = React.lazy(() => import("./Types/SaleOrder/SODetailList"))
const MUI_modal_rapide_vehicle_customer = React.lazy(
  () => import("./Types/modal_rapide_vehicle_customer")
)
/** Input Stock */
const MISDetail = React.lazy(() => import("./Types/InputStock/ISDetail"))
const MISDetailList = React.lazy(
  () => import("./Types/InputStock/ISDetailList")
)
const MISMasterInfo = React.lazy(
  () => import("./Types/InputStock/ISMasterInfo")
)
/** For Cell */
const MCIncDecNumber = React.lazy(() => import("./Types/Cell/IncDecNumber"))
const MCReadonlyStatus = React.lazy(() => import("./Types/Cell/ReadonlyStatus"))
/** For Edit */
const MUIEditCustomer = React.lazy(() => import("./Types/EditCustomer"))
const MUIEditVehicle = React.lazy(() => import("./Types/EditVehicle"))
const MUISelectPurchaseItems = React.lazy(
  () => import("./Types/SelectPurchaseItems")
)
/** */

const List = {
  wcontent: MWContent,
  unsupportedmedia: MUnsupportedMedia,
  quotemasterinfo: MQuoteMasterInfo,
  quotedetail: MQuoteDetail,
  quotetemplates: MQuoteTemplates,
  quotecustomer: MQuoteCustomer,
  quoteprogress: MQuoteProgress,
  quotedetaillist: MQuoteDetailList,
  quotetemplateadd: MQuoteTemplateAddition,
  quotedetailadd: MQuoteDetailAddition,
  quotepartdel: MQuotePartDelete,
  quotedetailformadd: MQuoteDetailFormAddition,
  quotetemplateaddition: MQuoteTemplateAdditionNew,
  jomasterinfo: MJOMasterInfo,
  joissueparts: MJOIssueParts,
  jodetail: MJODetail,
  jodetaillist: MJODetailList,
  ostockmasterinfo: MOSMasterInfo,
  osjobdetail: MOSJobDetail,
  osissueparts: MOSIssueParts,
  osissuepartsadd: MOSIssuePartsAddition,
  ospartissueddetail: MOSPartIssuedDetail,
  ospartissueddel: MOSPartIssuedDelete,
  createorderstockmasterInfo: MCreateOrderStockMasterInfo,
  createorderstockdetail: MCreateOrderStockDetail,
  createorderstockdetaillist: MCreateOrderStockDetailList,
  createorderstocklist: MCreateOrderStockList,
  somasterinfo: MSOMasterInfo,
  sodetail: MSODetail,
  sodetaillist: MSODetailList,
  soissueparts: MSOIssueParts,
  orderstockdetailmasterinfo: MOrderStockMasterInfo,
  orderstockdetailsupplier: MOrderStockSupplier,
  orderstockdetail: MOrderStockDetail,
  orderstockdetaillist: MOrderStockDetailList,
  orderstockdetailtimeline: MOrderStockDetailTimeline,
  isdetail: MISDetail,
  isdetaillist: MISDetailList,
  ismasterinfo: MISMasterInfo,
  // cell
  number_decimal: MCIncDecNumber,
  readonly_status: MCReadonlyStatus,
  modal_rapide_vehicle_customer: MUI_modal_rapide_vehicle_customer,
  // edit
  edit_customer: MUIEditCustomer,
  edit_vehicle: MUIEditVehicle,
  select_purchase_items: MUISelectPurchaseItems,
  orderstockaddnewpart: MUIOrderStockAddNewPart,
  // quote
  part_received_report: MPartReceivedDetailReport,
  client_main_concern: MClientMainConcern,
  quote_client_main_concern: MQuoteClientMainConcern,
}
const MyUIOne = {
  init() {
    MyUIHelpers.addTypesFromListLazy(List)
  },
}

export default MyUIOne
